export const getOrigin = () => {
	let origin;

	switch (process.env.NEXT_PUBLIC_ENVIRONMENT) {
		case 'prd':
			origin = 'https://www.hvac.com';
			break;
		case 'preview':
			origin = `https://${process.env.AWS_BRANCH}.${process.env.AWS_APP_ID}.amplifyapp.com`;
			break;
		case 'stg':
			origin = 'https://hvac-stg.mtechapis.com';
			break;
		case 'dev':
			origin = 'http://localhost:3000';
			break;
		default:
			origin = 'http://localhost:3000';
	}
	return origin;
};
